"use client";

import { c as _c } from "react/compiler-runtime";
import { useDropCurations } from "@/hooks/drops/useDropCurations";
export function useCurationManagementPermission(t0) {
  const $ = _c(8);
  const {
    curationId,
    probeDropId
  } = t0;
  const t1 = Boolean(probeDropId);
  let t2;
  if ($[0] !== probeDropId || $[1] !== t1) {
    t2 = {
      dropId: probeDropId,
      enabled: t1
    };
    $[0] = probeDropId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: t3
  } = useDropCurations(t2);
  let t4;
  if ($[3] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const probeCurations = t4;
  let t5;
  if ($[5] !== curationId || $[6] !== probeCurations) {
    t5 = probeCurations.find(curation => curation.id === curationId)?.authenticated_user_can_curate ?? false;
    $[5] = curationId;
    $[6] = probeCurations;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}